import { render, staticRenderFns } from "./AmazonPayButton.vue?vue&type=template&id=1a790222&scoped=true&"
import script from "./AmazonPayButton.vue?vue&type=script&lang=js&"
export * from "./AmazonPayButton.vue?vue&type=script&lang=js&"
import style0 from "./AmazonPayButton.vue?vue&type=style&index=0&id=1a790222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a790222",
  null
  
)

export default component.exports